import { useReadableEventRefresher } from '@zdrbm/zdr-react';
import type { IConversationRun } from 'features/pi/model/ConversationRun';

export function useConversationRunFeedback(run: IConversationRun) {
  const [[type], [content]] = useReadableEventRefresher(run.feedback.type, run.feedback.content);

  return { type, content };
}